import { DesktopLayoutStyles, previewSectionSizes } from '@MerchantConfigurator/constants';
import {
  getBackgroundColor,
  getContainer,
  getHorizontalBars
} from '@MerchantConfigurator/utils/CommonPreviewBlocks';

export const getDesktopPreviewHeader = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        width: DesktopLayoutStyles.width,
        height: previewSectionSizes['4xl'],
        backgroundColor: getBackgroundColor({
          darkMode,
          backgroundColor: 'backgroundAlternateColor'
        }),
        justifyContent: 'space-between'
      }
    }),
    blocks: [
      //store name bar
      ...getHorizontalBars({
        style: {
          width: previewSectionSizes['4xl'],
          height: previewSectionSizes.sm,
          marginLeft: previewSectionSizes['2xl'],
          backgroundColor: getBackgroundColor({
            darkMode,
            backgroundColor: 'componentsColor'
          })
        },
        number: 1
      }),
      //right side tabs - 3 nav bars
      {
        ...getContainer({
          style: {
            gap: previewSectionSizes.md,
            marginRight: previewSectionSizes['2xl']
          }
        }),
        blocks: getHorizontalBars({
          style: {
            width: previewSectionSizes['2xl'],
            height: previewSectionSizes.sm,
            backgroundColor: getBackgroundColor({
              darkMode,
              backgroundColor: 'componentsColor'
            })
          },
          number: 3
        })
      }
    ]
  };
};

export const getDesktopPreviewFooter = ({ darkMode }) => {
  return {
    ...getContainer({
      style: {
        width: 'inherit',
        height: previewSectionSizes['2xl'],
        backgroundColor: getBackgroundColor({
          darkMode,
          backgroundColor: 'backgroundAlternateColor'
        })
      }
    })
  };
};
